<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-select v-model="form.enable" clearable  placeholder="全部">
                        <el-option label="开启" :value="true"></el-option>
                        <el-option label="关闭" :value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="add()">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="机构名称" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="域名" >
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" :href="'http://'+scope.row.domain+'.leadersir.cn'">{{scope.row.domain}}.leadersir.cn</el-link>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="负责人" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <span>{{scope.row.contactName}}</span>
                            <span>{{scope.row.phone}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="是否开启" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enable"
                                   @change="modifyEnable(scope.row)"
                                   inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="createTime"
                    label="创建时间" >
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该下级机构吗？"
                        >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

        <AddDrawer v-if="showAdd" @submit="loadData"
                  @close="showAdd=false" :item="editItem"></AddDrawer>
    </div>
</template>

<style scoped>

</style>
<style>

</style>

<script>

    import AddDrawer from './AddDrawer';
    import {mapMutations} from "vuex";

    export default {
        components: {
            AddDrawer,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                editItem: {},
                showAdd: false,

                form: {
                    keywords: "",
                    enable: null,
                    type: 2,
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            add() {
                this.editItem = {};
                this.showAdd = true;

            },
            edit(item) {
                this.openTab({
                    funcKey: "school_page_subinstitution_edit",
                    attr: {subInstitution: item},
                    title: "设置【"+item.name+"】",
                    allowDuplicate: true
                });
            },

            del(item) {
                this.$ajaxGet("/institution/del/" + item.id, (data) => {
                    this.loadData();
                })
            },

            modifyEnable(item) {
                this.$ajaxGet("/institution/toggleEnable/" + item.id + "-" + item.enable);
            },

            loadData() {
                this.$ajaxPost("/institution/listSubInstitution", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showAdd = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            }

        },

        created() {
            this.loadData();
        }

    }
</script>
